import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE, withCredentials: true, timeout: 30000 });

// Session lives only in the secure httpOnly cookie; "crm_session" is a non-secret flag.
localStorage.removeItem("crm_token");

api.interceptors.response.use(undefined, (err) => {
  const url = err?.config?.url || "";
  if (err?.response?.status === 401 && localStorage.getItem("crm_session") && !url.startsWith("/auth/")) {
    localStorage.removeItem("crm_session");
    if (!window.location.pathname.startsWith("/login")) window.location.assign("/login?expired=1");
  }
  return Promise.reject(err);
});

export const isNetworkError = (err) => !err?.response && (err?.code === "ECONNABORTED" || err?.code === "ERR_NETWORK" || err?.message === "Network Error" || /timeout/i.test(err?.message || ""));

export function formatError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (!err?.response) {
    if (err?.code === "ECONNABORTED" || /timeout/i.test(err?.message || "")) return "The server took too long to respond. Please check your connection and try again.";
    return "Network connection problem. Please check your internet connection and try again.";
  }
  if (status === 401) return "Your session has expired. Please sign in again.";
  if (detail == null || status >= 500) {
    if (status === 403) return "You do not have permission to perform this action.";
    if (status >= 500) return "The service is temporarily unavailable. Please try again in a moment.";
    return "Something went wrong. Please try again.";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail === "object" && detail.message) return detail.message;
  return String(detail);
}

export default api;
